import { ClipLoader } from "react-spinners"
import React from "react"

const Spinner = ({ isFetching, style: customStyles = {} }) => {
  const style = {
    display: "flex",
    justifyContent: "center",
    ...customStyles,
    padding: "16px 0",
  }
  return (
    <div style={style}>
      <ClipLoader color={"#123abc"} loading={isFetching} />
    </div>
  )
}

export default Spinner
